import { joinTokenString } from "@/utils/medplum";

import { ACTIVE_FLAG_STATUS } from "../constants/flags";

/**
 * The query that pins one identifier to one active `Flag` under one subject.
 *
 * Both flag writes are guarded by one of these — a library entry keyed by its derived code under the
 * practice's Flag Library Group, and an applied flag keyed by its library entry under a Patient. It
 * is the `If-None-Exist` a conditional create is sent with, and the search a rename checks itself
 * against.
 *
 * Matches on `identifier` because R4 gives `Flag` no `code` search param, and narrows by `subject`
 * rather than folding the subject into the identifier value, so two subjects stay free to hold the
 * same identifier.
 *
 * `status` narrows it to active flags, which is what lets an identifier be reused after a delete:
 * the inactive resource keeps it, so one identifier can be held by one active flag and any number of
 * deactivated ones.
 *
 * @param system - Identifier system to match on
 * @param value - Identifier value — a derived library code, or a library entry's logical id
 * @param subject - `Group/{id}` of a practice's library, or `Patient/{id}` of a chart
 */
export function buildActiveFlagQuery({
  system,
  value,
  subject,
}: {
  system: string;
  value: string;
  subject: string;
}): string {
  return new URLSearchParams({
    identifier: joinTokenString(system, value)!,
    subject,
    status: ACTIVE_FLAG_STATUS,
  }).toString();
}
